import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import Menu from "../Menu";

const DuplicateShares: React.FC = () => {
  const contentContainerRef = useRef<HTMLDivElement | null>(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (contentContainerRef.current) {
        const contentRect = contentContainerRef.current.getBoundingClientRect();
        setIsSticky(contentRect.top <= 0);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div ref={contentContainerRef}>
      {/* Static Banner Section */}
      <Box
        sx={{
          width: "100%",
          height: "50vh",
          position: "relative",
          overflow: "hidden",
          background: `
            linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)),
            url(${"/assets/service_01.jpg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Menu isSticky={isSticky} />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#fff",
            textAlign: "center",
          }}
        >
          <Typography variant="h3" fontWeight="bold" letterSpacing={1}>
            Duplicate Issue of Shares
          </Typography>
        </Box>
      </Box>
  
      {/* Sections Below */}
      <Box sx={{ padding: "20px", backgroundColor: "#f9f9f9", color: "#000" }}>
        <Box
          sx={{
            padding: "20px",
            margin: "20px auto",
            maxWidth: "800px",
          }}
        >
          {/* Procedure Section */}
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Procedure for Issuance of Duplicate Share Certificate
          </Typography>
  
          {/* Step 1 */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 1 }}>
            1. Inform the Company or Registrar & Transfer Agent (RTA)
          </Typography>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li><Typography variant="body1">Notify the company or its RTA about the loss of the share certificate.</Typography></li>
            <li><Typography variant="body1">Provide details such as folio number, share certificate number, and distinctive numbers.</Typography></li>
          </ul>
  
          {/* Step 2 */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 1 }}>
            2. File an FIR (if required)
          </Typography>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li><Typography variant="body1">Some companies may require an FIR or police complaint mentioning the lost certificate details.</Typography></li>
            <li><Typography variant="body1">If the value of securities is below a certain threshold (e.g., ₹5 lakhs), filing an FIR may not be mandatory.</Typography></li>
          </ul>
  
          {/* Step 3 */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 1 }}>
            3. Submit Required Documents
          </Typography>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li><Typography variant="body1">Indemnity Bond on non-judicial stamp paper (as per company requirements).</Typography></li>
            <li><Typography variant="body1">Affidavit confirming the loss or damage of the certificate.</Typography></li>
            <li><Typography variant="body1">Advertisement in a newspaper (if required) announcing the loss of the certificate.</Typography></li>
            <li><Typography variant="body1">KYC documents such as Aadhaar, PAN, and address proof.</Typography></li>
          </ul>
  
          {/* Step 4 */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 1 }}>
            4. Company Verification & Approval
          </Typography>
          <Typography variant="body1" paragraph>
            The company or RTA will verify the documents and may seek additional information if necessary.  
            Approval is granted by the Board of Directors through a formal resolution.
          </Typography>
  
          {/* Step 5 */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 1 }}>
            5. Issuance of Duplicate Share Certificate
          </Typography>
          <Typography variant="body1" paragraph>
            Once approved, the company issues a duplicate share certificate with a clear marking:
            <br />
            <i>"Issued in lieu of share certificate No. [original certificate number]"</i>
            <br />
            The issuance details are recorded in Form SH-2 as per regulatory requirements.
          </Typography>
  
          {/* Step 6 */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 1 }}>
            6. Timeframe for Issuance
          </Typography>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li><Typography variant="body1"><strong>Listed Companies:</strong> Typically within 30 days from the date of application.</Typography></li>
            <li><Typography variant="body1"><strong>Unlisted Companies:</strong> Within 3 months from the date of submission.</Typography></li>
          </ul>
        </Box>
      </Box>
    </div>
  );
};

export default DuplicateShares;
